/* eslint-disable */
import { createRoot } from "react-dom/client";
import { scan } from "react-scan"; // must be imported before React and React DOM
import AppInitializer from "./AppInitializer";

scan({
  enabled: false,
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<AppInitializer />);
